// extracted by mini-css-extract-plugin
export default {"tablecss":"styles_tablecss__-tbPg"};